import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhoneDynamicIsland: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPhoneDynamicIsland"><Path fillRule="evenodd" clipRule="evenodd" d="M5 23V1H19V23H5ZM10 3.49V4.99H14V3.49H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhoneDynamicIsland;
